module.exports = __webpack_public_path__ + "img/pluto40.f4ce25ec.jpg";